import { NavLink } from "react-router-dom";
import { products } from "@/data/products";

const brandOrder = ["Eleventy", "Herno", "BOSS", "Dondup", "Dsquared2", "Tommy Hilfiger", "Diesel"];

function getBrandImage(brand: string): string {
  const p = products.find((x) => x.brand === brand);
  return p?.image ?? "";
}

function getBrandCount(brand: string): number {
  return products.filter((p) => p.brand === brand).length;
}

export function BrandSpotlight() {
  return (
    <section className="py-10 md:py-16 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <p className="text-[10px] sm:text-[11px] tracking-[0.3em] uppercase text-emerald-600 font-semibold mb-2 md:mb-3">
            I brand che trovi su Brupa
          </p>
          <h2 className="text-xl sm:text-2xl md:text-5xl text-stone-900 font-semibold md:font-bold tracking-tight leading-[1.05]">
            Brand in evidenza
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {brandOrder.map((brand) => {
            const img = getBrandImage(brand);
            const count = getBrandCount(brand);
            return (
              <NavLink
                key={brand}
                to={`/shop?brand=${encodeURIComponent(brand)}`}
                className="group relative overflow-hidden aspect-[4/5] bg-stone-200 block"
              >
                {img && (
                  <img
                    src={img}
                    alt={brand}
                    className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
                  />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-stone-900/80 via-stone-900/20 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="text-white text-sm sm:text-base md:text-xl font-medium md:font-semibold tracking-tight leading-tight">{brand}</h3>
                  <p className="text-stone-300 text-[10px] tracking-[0.25em] uppercase mt-1">
                    {count} {count === 1 ? "articolo" : "articoli"}
                  </p>
                  <span className="mt-3 inline-block text-[10px] tracking-widest uppercase text-white/70 group-hover:text-white transition-colors border-b border-white/30 group-hover:border-white pb-0.5">
                    Scopri →
                  </span>
                </div>
              </NavLink>
            );
          })}

          {/* Card finale — vedi tutti i brand */}
          <NavLink
            to="/shop"
            className="group relative overflow-hidden aspect-[4/5] bg-stone-900 flex flex-col items-center justify-center text-center p-6"
          >
            <p className="text-[11px] tracking-[0.3em] uppercase text-emerald-400 font-semibold mb-3">E molti altri</p>
            <h3 className="text-white text-xl sm:text-2xl md:text-3xl font-semibold md:font-bold tracking-tight leading-tight mb-6">
              Tutta la<br />collezione
            </h3>
            <span className="text-[10px] tracking-widest uppercase text-white border border-white/40 px-6 py-2.5 group-hover:bg-white group-hover:text-stone-900 transition-colors">
              Esplora
            </span>
          </NavLink>
        </div>
      </div>
    </section>
  );
}
